import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {OpplastetDokument, Skyfil} from "web-ng2/delt/komponenter/filvelger-skytjenester/SkyfilOpplasting";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

const debug = initDebugger('OpplastingsstatusSkyfilerKomponent');

export type OpplastingsstatusSkyfilerModus = 'lasterOpp' | 'bekreftNyeVersjoner' | 'opplastingFeilet';

/**
 * Komponent som viser opplastingsstatus for filer valgt fra sky (OneDrive/Google Drive)
 */
@Component({
    selector: 'opplastingsstatus-skyfiler',
    templateUrl: 'opplastingsstatus-skyfiler.html',
    styleUrl: 'opplastingsstatus-skyfiler.scss',
    imports: [
        MatButton,
        MatProgressSpinner,
        TranslateModule,
        InlineMeldingKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OpplastingsstatusSkyfilerKomponent {

    vedStartOpplasting = output();
    vedAvbryt = output();
    vedLukk = output();

    filerUnderOpplasting = input.required<FilMedOpplastingsstatus[]>();
    nyeVersjoner = input.required<ValgtFil[]>();
    modus = input.required<OpplastingsstatusSkyfilerModus>();

    visRegistrerNyeVersjonsBekreftelse = computed(() => this.modus() == 'bekreftNyeVersjoner');

    constructor() {
    }

    startOpplasting() {
        this.vedStartOpplasting.emit();
    }

    /** Bruker klikket på avbryt etter at filer har blitt valgt, opplasting av filer er antagelig pågående */
    avbrytLastOpp() {
        this.vedAvbryt.emit()
    }

    lukk(){
        this.vedLukk.emit()
    }

    static oppdaterOpplastetStatus(opplastet: OpplastetDokument<Skyfil>, filer: FilMedOpplastingsstatus[]) {
        const valgteFiler = [...filer];
        const aktuellFil = valgteFiler.find(fil => fil.fil.filnavn == opplastet.opplastetFil.filnavn)!;
        if (erIkkeNil(opplastet.feil))
            aktuellFil.feilet = true;
        else
            aktuellFil.lastetOpp = true;
        return valgteFiler;
    }

    static medOpplastetStatus(filer: ValgtFil[]): FilMedOpplastingsstatus[] {
        return filer.map(fil => ({fil: fil, lastetOpp: false, feilet: false}));
    }

}

export interface ValgtFil {
    filnavn: string;
}

export interface FilMedOpplastingsstatus {
    fil: ValgtFil;
    lastetOpp: boolean;
    feilet: boolean;
}

